import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomerStateFacade, StoreErrorHandler } from '@zero/shared/util-global-state';
import { catchError, filter, map, of, switchMap, take, tap } from 'rxjs';
import { TaxInfrastructure } from '../../infrastructure/tax.infastructure';
import { taxActions, taxApiActions } from './tax.actions';

@Injectable({ providedIn: 'root' })
export class TaxEffects {
  readonly #actions = inject(Actions);
  readonly #taxInfrastructure = inject(TaxInfrastructure);
  readonly #customerStateFacade = inject(CustomerStateFacade);
  readonly #storeErrorHandler = inject(StoreErrorHandler);

  public loadTax$ = createEffect(() => {
    return this.#actions.pipe(
      ofType(taxActions.loadTaxData),
      tap(() => this.#customerStateFacade.loadCustomerBaseData()),
      switchMap(() =>
        this.#customerStateFacade.customerBaseData$.pipe(
          filter((customerBaseData) => !!customerBaseData),
          take(1),
          switchMap(({ customerId }) =>
            this.#taxInfrastructure.getTaxData(customerId).pipe(
              map((tax) => taxApiActions.loadTaxDataSuccess({ tax })),
              catchError((error) => of(taxApiActions.loadTaxDataFailure({ error }))),
            ),
          ),
        ),
      ),
    );
  });

  public handleBackendErrors$ = createEffect(
    () => {
      return this.#actions.pipe(
        ofType(taxApiActions.loadTaxDataFailure),
        tap((error) => this.#storeErrorHandler.handleBackendError(error)),
      );
    },
    { dispatch: false },
  );
}
